export default __webpack_public_path__ + "media/images/tenant/timeline/step_2-4f840d0e6e7d0851969a0af50da07459.jpg";